import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

//get sub order person by paging
const getSubOrderByPaging = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/all/" +
          offset +
          "/" +
          pageSize,
        {
          subOrderPersonIds:
            filter._subOrderPersonIds.length > 0
              ? filter._subOrderPersonIds
              : null,
          inputImportIds:
            filter._inputImportIds.length > 0
              ? filter._inputImportIds
              : null,
          outputImportIds:
            filter._outputImportIds && filter._outputImportIds.length > 0
              ? filter._outputImportIds
              : null,
          status: filter._status || null,
          orderId: filter._orderId ? String(filter._orderId).trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch((error) => {
        return "Something went wrong...";
      });
  }
};

//add sub order
const addSubOrder = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(process.env.REACT_APP_API_URL + "/api/sub-order/add", values, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("add sub order error " + error);
        return false;
      });
  }
};

//add sub order payment
const addSubOrderPayment = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/sub-order/payment",
        {
          orderId: values._orderId,
          addedBy: user.username,
          note: values._note,
          amount: values._amount,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("add sub order payment error " + error);
        return false;
      });
  }
};

//delete sub order payment
const deleteSubOrderPayment = async (paymentId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/payment/delete/" +
          paymentId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Delete sub order payment " + error);
        return false;
      });
  }
};

const sendForApprovalSubOrderPayment = async (paymentId, orderId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/send-approval/" +
          paymentId +
          "/" +
          orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Send approval sub order payment " + error);
        return false;
      });
  }
};

const approveSubOrderPayment = async (orderId, paymentId, isApproved) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/approve-payment/" +
          paymentId +
          "/" +
          isApproved,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        const redirectUrl = `/template/im_bill_return_view/${orderId}`;
        window.location.href = redirectUrl;
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Unable to approve or reject sub order payment " + error);
        return false;
      });
  }
};

const markAsPaidSubOrderPayment = async (paymentId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/mark-as-payment/" +
          paymentId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Unable to mark sub order payment " + error);
        return false;
      });
  }
};

//validate sub order quantities...
const validateSubOrder = async (orderId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/sub-order/validate/" + orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("validate Sub Order " + error);
        return "Something went wrong...";
      });
  }
};

// send for approval sub order
const sendForApproval = async (orderId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/send-approval/" +
          orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Unable to mark sub order payment " + error);
        return false;
      });
  }
};

// send for approval sub order
const subOrderApproval = async (orderId, isApproved) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/approval/" +
          orderId +
          "/" +
          isApproved,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("Unable to mark sub order payment " + error);
        return false;
      });
  }
};

//get Sub Order by Id
const getSubOrderById = async (orderId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/sub-order/" + orderId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sub Order " + error);
        return "Something went wrong...";
      });
  }
};

//send for order completion Sub Order by Id
const completeSubOrder = async (orderId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/confirm-completion/" +
          orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sub Order " + error);
        return false;
      });
  }
};

//confirm Sub Order by Id
const confirmCompleteSuborder = async (orderId, isAccepted) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/confirm-received/" +
          orderId +
          "/" +
          isAccepted,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sub Order " + error);
        return false;
      });
  }
};

//delete sub order according to the given Id
const deleteSubOrderById = async (orderId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL + "/api/sub-order/delete/" + orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sale product " + error);
        return false;
      });
  }
};

const forceDeleteSubOrder = async (orderId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL + "/api/sub-order/force/" + orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(() => true)
      .catch((error) => {
        console.error("forceDeleteSubOrder error:", error);
        return false;
      });
  }
};

const updateSubOrderLineItem = async (orderId, values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/update/lineitem/" +
          orderId,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        if (response.data) {
          return true;
        } else {
          return false;
        }
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("add sub order line item error " + error);
        return false;
      });
  }
};

// ==========================================
// NEW METHODS FOR RECEIVING & CHECKING
// ==========================================

/**
 * Receive OUTPUT line items
 * POST /api/sub-order/receive
 *
 * @param {Object} receiveData - { lineItemId, receivedQty, receivedBy, notes, reconstructionId }
 * @returns {Object|null} - Receive record or null
 */
const receiveOutputLineItem = async (receiveData) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/sub-order/receive",
        receiveData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("[RECEIVE OUTPUT] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error receiving output items:", error);
        return null;
      });
  }
};

/**
 * Check received batch (Quality Control)
 * POST /api/sub-order/check
 *
 * @param {Object} checkData - { receiveId, checkedQty, damagedQty, checkedBy, notes }
 * @returns {Object|null} - Check record or null
 */
const checkReceivedBatch = async (checkData) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(process.env.REACT_APP_API_URL + "/api/sub-order/check", checkData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("[CHECK BATCH] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error checking batch:", error);
        return null;
      });
  }
};

/**
 * Get all receive records for a specific line item
 * GET /api/sub-order/receive/line-item/{lineItemId}
 *
 * @param {Number} lineItemId - Line item ID
 * @returns {Array|null} - Array of receive records or null
 */
const getLineItemReceives = async (lineItemId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/receive/line-item/" +
          lineItemId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("[GET RECEIVES] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching receive records:", error);
        return null;
      });
  }
};

/**
 * Get receiving progress for all OUTPUT items in a sub order
 * GET /api/sub-order/progress/{orderId}
 *
 * @param {Number} orderId - Sub order ID
 * @returns {Array|null} - Array of ReceivingProgressDTO or null
 */
const getSubOrderReceivingProgress = async (orderId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/sub-order/progress/" + orderId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("[GET PROGRESS] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching receiving progress:", error);
        return null;
      });
  }
};

/**
 * Get all damaged batches across all orders
 * GET /api/sub-order/damaged-batches
 *
 * @returns {Array|null} - Array of check records with damaged items or null
 */
const getAllDamagedBatches = async () => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/sub-order/damaged-batches", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("[GET DAMAGED] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching damaged batches:", error);
        return null;
      });
  }
};

/**
 * Create a reconstruction batch for damaged items
 * POST /api/sub-order/reconstruct
 * 
 * @param {Object} reconstructionData - Reconstruction details
 * @returns {Object|null} - Reconstruction record or null
 */
const createReconstructionBatch = async (reconstructionData) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/sub-order/reconstruct",
        reconstructionData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("[CREATE RECONSTRUCTION] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error creating reconstruction:", error);
        return null;
      });
  }
};

/**
 * Get reconstruction history for a check record
 * GET /api/sub-order/reconstruct/check/{checkId}
 * 
 * @param {Number} checkId - Check record ID
 * @returns {Array|null} - Array of reconstruction records or null
 */
const getReconstructionsByCheckId = async (checkId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/reconstruct/check/" +
          checkId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("[GET RECONSTRUCTIONS] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching reconstructions:", error);
        return null;
      });
  }
};

/**
 * Update reconstruction status
 * PUT /api/sub-order/reconstruct/{reconstructionId}/status/{status}
 * 
 * @param {Number} reconstructionId - Reconstruction ID
 * @param {String} status - New status (IN_PROGRESS, COMPLETED, CANCELLED)
 * @returns {Object|null} - Updated reconstruction record or null
 */
const updateReconstructionStatus = async (reconstructionId, status) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .put(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/reconstruct/" +
          reconstructionId +
          "/status/" +
          status,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("[UPDATE RECONSTRUCTION STATUS] Success:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error updating reconstruction status:", error);
        return null;
      });
  }
};


const getAwaitingPaymentOrdersByPerson = async (personId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/sub-order/person/" +
          personId +
          "/awaiting-payment",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("getAwaitingPaymentOrdersByPerson error: " + error);
        return "Something went wrong...";
      });
  }
};

const getSubOrdersForReport = async (startDate, endDate) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/sub-order/all/0/1000",
        {
          subOrderPersonIds: null,
          inputImportIds: null,
          outputImportIds: null,
          status: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("[getSubOrdersForReport] error:", error);
        return null;
      });
  }
};

// ==========================================
// EXPORTS
// ==========================================

const deleteSubOrderLineItem = async (lineItemId) => {
  const valid = await token_valid();
  if (!valid) return false;
  const token = getToken();
  return axios
    .delete(
      process.env.REACT_APP_API_URL + "/api/sub-order/lineitem/" + lineItemId,
      { headers: { Authorization: "Bearer " + token } }
    )
    .then((res) => res.data === true)
    .catch((err) => {
      console.log("deleteSubOrderLineItem error", err);
      return false;
    });
};

const requestSubOrderLineItemDeletion = async (lineItemId) => {
  const valid = await token_valid();
  if (!valid) return false;
  const token = getToken();
  return axios
    .post(
      process.env.REACT_APP_API_URL + "/api/sub-order/lineitem/request-delete/" + lineItemId,
      {},
      { headers: { Authorization: "Bearer " + token } }
    )
    .then(() => true)
    .catch((err) => {
      console.log("requestSubOrderLineItemDeletion error", err);
      return false;
    });
};

const rejectSubOrderLineItemDeletion = async (lineItemId) => {
  const valid = await token_valid();
  if (!valid) return false;
  const token = getToken();
  return axios
    .post(
      process.env.REACT_APP_API_URL + "/api/sub-order/lineitem/reject-delete/" + lineItemId,
      {},
      { headers: { Authorization: "Bearer " + token } }
    )
    .then(() => true)
    .catch((err) => {
      console.log("rejectSubOrderLineItemDeletion error", err);
      return false;
    });
};

export {
  // Existing exports
  getSubOrderByPaging,
  addSubOrder,
  getSubOrderById,
  addSubOrderPayment,
  deleteSubOrderPayment,
  completeSubOrder,
  confirmCompleteSuborder,
  deleteSubOrderById,
  updateSubOrderLineItem,
  sendForApprovalSubOrderPayment,
  approveSubOrderPayment,
  markAsPaidSubOrderPayment,
  validateSubOrder,
  sendForApproval,
  subOrderApproval,
  // NEW: Receiving & Checking exports
  receiveOutputLineItem,
  checkReceivedBatch,
  getLineItemReceives,
  getSubOrderReceivingProgress,
  getAllDamagedBatches,
  createReconstructionBatch,
  getReconstructionsByCheckId,
  updateReconstructionStatus,
  getAwaitingPaymentOrdersByPerson,
  getSubOrdersForReport,
  forceDeleteSubOrder,
  deleteSubOrderLineItem,
  requestSubOrderLineItemDeletion,
  rejectSubOrderLineItemDeletion,
};
